// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spinner {\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    border: 10px solid rgba(255, 255, 255, 0.3);\n    border-top: 10px solid #E5F68C;\n    animation: spin 2s linear infinite;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  ", ""]);
// Exports
module.exports = exports;
